// @flow

import styled, { css } from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";
import DefaultButton from "../../_atoms/ButtonDefault";

export const Wrapper = styled.div`
  position: relative;
  background-color: ${buildColor("white", "100")};
`;

export const ConfirmationButtonContainer = styled.div`
  padding: 12px 16px;
  padding-bottom: calc(12px + constant(safe-area-inset-bottom));
  padding-bottom: calc(12px + env(safe-area-inset-bottom));

  & > button {
    flex: 1 0;
  }

  & > button:not(:first-child) {
    margin-left: 4px;
  }

  text-align: right;
  display: flex;
  justify-content: space-between;
  background-color: ${buildColor("white", "100")};
  ${({ withTopBorder }) =>
    withTopBorder &&
    css`
      border-top: 1px solid ${buildColor("grey", "300")};
    `}
  position: sticky;
  left: 0;
  right: 0;
  bottom: 0;
`;

export const BetSummaryContainer = styled.div`
  padding: 0 16px;
  ${(props) =>
    props.hasBottomMargin &&
    css`
      margin-bottom: 12px;
    `};
`;

export const DoneButton = styled(DefaultButton)`
  font-size: 12px;
  background-color: transparent;
  color: ${buildColor("blue", "500")};
  margin-right: 20px;
  font-weight: bold;
`;

export const FloatingBannerWrapper = styled.div`
  padding: 12px 12px 0;
`;

export const WagerAmountContainer = styled.span``;
